import { MOBILE_BREAKPOINT } from '@/config';
/**
 * Check if device is phone or tablet
 * @returns true if the device is touch-enabled, false otherwise
 */
function isTouchDevice(): boolean {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

function isMobile(): boolean {
    // Check if the device is a phone or tablet based on screen width and touch support
    return window.innerWidth <= MOBILE_BREAKPOINT || isTouchDevice();
}

export { isMobile, isTouchDevice };
